import { apiClient } from './apiClient';

const fetchUserProfile = async () => {
  return await apiClient.get('/dashboard/profile');
};

const updateUserProfile = async (payload) => {
  return await apiClient.patch('/dashboard/profile', payload);
};

export const profileApi = {
  fetchUserProfile,
  updateUserProfile
};
